import axios from 'axios';

// axios.defaults.withCredentials = true;
const service = axios.create({
  // baseURL: 'http://172.16.15.110:19001/g-app', // api 的 base_url
  // baseURL: '/g-app', // api 的 base_url
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  timeout: 60000, // request timeout
});

service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);


service.interceptors.response.use(
  (response) => {
    const { status, data } = response;
    if (Array.isArray(data)) {
      return Promise.resolve(data);
    }
    if (status === 200 && data.code === 200) {
      return Promise.resolve(data);
    }
    if (data.msg) {
      alert(data.msg);
    }
    return Promise.reject(data);
  },
  (error) => {
    console.dir(error);
  },

);

/* eslint-disable */
// 获取历史下载版本
export function getHistoryVersions(params) {
  return service.get('/agent/app/version/history', { params });
}
